"use client";
import React, { useState } from "react";
import makeApiCall from "@packages/lib/server-actions/rest-api";
import API_URL from "@packages/lib/server-actions/api-urls";
import {
  clickstreamForClicks,
  gaForCtaClicks,
  isWhatuni,
  oldGAForCtaClicks,
} from "@packages/lib/utlils/commonFunction";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import { ClickstreamConstants } from "@packages/shared-components/services/constants";
import ButtonLoader from "./ButtonLoader";
import { buildBookingUrl } from "@packages/lib/utlils/revenue-buttons/button-logic-util";
import { getCustomDomain } from "@packages/lib/utlils/common-function-server";

const BookOpenDay = ({
  enquiryProps,
  commonGAAttrs,
  btnSize = "w-full",
  btnName,
  commonOldGAAttrs
}: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getButtonText = () => isWhatuni() ? (btnName || "Book open day") : "Book event";

  const createCSData = (): ClickstreamInterface => ({
    CTATitle: getButtonText(),
    actionType: ClickstreamConstants.clickAction,
    functionalityName: enquiryProps?.sponsoredListingFlag === "Y" ? "Sponsor listing" : "Openday",
  });

  const getSectionData = (id:any): string | null => {
    const element = document.getElementById("book-openday-btn");
    const sectionName = element?.getAttribute(id) || null;
    element?.removeAttribute(id);
    return sectionName;
  };

  const buildGAAttrs = (sectionName:any,buttonText:any) => ({
    ...commonGAAttrs,
    page_section: sectionName || commonGAAttrs.page_section,
    study_mode: enquiryProps?.studyMode || "na",
    click_text: buttonText || "book open day",
    //...(sessionStorage.getItem("veppleProviders") && { data_label5: "vepple_driven" }),
  });
  const buildOldGAAttrs = (sectionName:any,buttonText:any) => ({
    ...commonOldGAAttrs,
    data_label: sectionName || commonGAAttrs.page_section,
    study_mode: enquiryProps?.studyMode || "na",
    cta_name: buttonText || "Book open day",
    ...(sessionStorage.getItem("veppleProviders") && { data_label5: "vepple_driven" }),
  });

  const createPayload = () => ({
    suborderItemId: enquiryProps?.subOrderItemId,
    orderItemId: enquiryProps?.orderItemId,
    collegeId: enquiryProps?.collegeId,
    courseId: enquiryProps?.courseId,
    affiliateId: process.env.AFFILATE_ID,
    qualCode: enquiryProps?.qualCode,
  });

  const processBookingResponse = (response: any) => {
    const isInternal = response?.onsiteBookingForm?.toLowerCase() === "y";
    return {
      url: isInternal ? buildBookingUrl(response, enquiryProps) : response?.bookingUrl,
      eventType: isInternal ? "BookEventInternalLinkClicked" : "BookEventExternalLinkClicked",
      isInternal,
    };
  };

  const handleBookOpenDay = async () => {
    setIsLoading(true);
    const sectionName = getSectionData("data-section-name");
    const buttonText = getSectionData("data-button-text");
    const localGAAttrs = buildGAAttrs(sectionName,buttonText);
    const localOldGAAttrs = buildOldGAAttrs(sectionName,buttonText);
    const csData = createCSData();

    try {
      const response = await makeApiCall({
        url: `${process.env.NEXT_PUBLIC_DOMSERVICE_API_DOMAIN}/${API_URL?.getEnquiryDetails}`,
        method: "POST",
        body: createPayload(),
        headers: { "x-api-key": process.env.NEXT_PUBLIC_DOMSERVICE_X_API_KEY || "" },
      });

      const { url, eventType, isInternal } = processBookingResponse(response);
      Object.assign(csData, {
        eventType,
        eventId: response?.eventId || "",
        externalUrl: response?.bookingUrl || "",
      });
      enquiryProps.event = isInternal ? (isWhatuni() ? "book_event_request" : "open_days_internal") : (isWhatuni() ?  "book_event_external" : "open_days_external"),
      enquiryProps.url = isInternal ? getCustomDomain() + url : url;
      enquiryProps.revenueValue = isInternal ? response?.opendayEventPrice : response?.opendayPrice
      gaForCtaClicks(
        enquiryProps,
        isInternal ? "book_open_day_internal" : "book_open_day_external",
        localGAAttrs,
        response.cpeFlag,
        ""
      );
       oldGAForCtaClicks(
        enquiryProps,
        isWhatuni() ? "Book open day" : "Book event",
        enquiryProps.url,
        enquiryProps.event,
        localOldGAAttrs,
        response.cpeFlag,
        ""
      );
      
      await clickstreamForClicks(enquiryProps, csData, commonGAAttrs);
      window.open(url, isInternal ? "_self" : "_blank");
    } catch (error) {
      console.error("Error fetching enquiry data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      type="button"
      className={`btn btn-green w-full flex items-center justify-center ${btnSize}`}
      onClick={handleBookOpenDay}
      id="book-openday-btn"
    >
      <ButtonLoader isLoading={isLoading}>
        {getButtonText()}
      </ButtonLoader>
    </button>
  );
};

export default BookOpenDay;
